import ConversationsNearby from 'views/conversationsNearby/ConversationNearBy.container';

export default ConversationsNearby;